"use client"

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  type ToastPosition
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"

export function Toaster() {
  const { toasts } = useToast()

  // Get the position from the first toast, or use default
  // Using a type assertion as we've updated the ToasterToast type
  const position = "top-right";
  // const position = (toasts[0]?.position as ToastPosition) || "top-right";

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, position: _, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport position={position} />
    </ToastProvider>
  )
}
